exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-box[data-v-1025e03c] .yxt-select{width:328px}.sel-type-item[data-v-1025e03c] .yxt-radio__label{display:inline-flex;align-items:center}.sel-type-item[data-v-1025e03c] .yxt-form-item__content{height:40px;display:flex;align-items:center}\n", ""]);

